import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NavDprSectionsSubmenuPage } from './nav-dpr-sections-submenu';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    NavDprSectionsSubmenuPage,
  ],
  imports: [
    IonicPageModule.forChild(NavDprSectionsSubmenuPage),
    DirectivesModule,
  ],
})
export class NavDprSectionsSubmenuPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-dpr-sections-submenu/nav-dpr-sections-submenu.module.ts